import { useEffect } from 'react';
import { Redirect, Switch } from 'react-router-dom';

import includes from 'lodash/includes';
import PropTypes from 'prop-types';

import VisitorLogTableComponent from './VisitorLogTableContainer';
import VisitorProfileContainer from './VisitorProfileContainer';
import VisitorTableComponent from './VisitorTableContainer';

import ManageVisitorRouterComponent from './ManageVisitorRouterComponent';

import { isSuperOrConcierge } from '../../utils';

import Route from '../../routes/SentryRoute';
import TabsComponentWithLinks from '../Tabs/TabsComponentWithLinks';
import VMSContainer from '../VisitorManagementSettings';

const VisitorRouterComponent = (props) => {
  const { match, location } = props;

  useEffect(() => {
    document.title = 'Visitors';
  }, []);

  const tabData = [
    {
      label: 'Visitors and Brokers',
      url: `${match.path}/list`,
    },
    {
      label: 'Visitors/Brokers Log',
      url: `${match.path}/log`,
    },
    {
      label: 'Visitor Settings',
      url: `${match.path}/settings`,
    },
  ];
  if (isSuperOrConcierge(match?.params)) tabData.pop();
  const isFormComponent =
    includes(location.pathname, 'create') ||
    includes(location.pathname, 'update') ||
    includes(location.pathname, 'profile');
  return (
    <>
      {!isFormComponent && (
        <TabsComponentWithLinks
          key="TabsComponentWithLinks"
          tabData={tabData}
          currentUrl={location.pathname}
        />
      )}
      <Switch>
        <Route
          exact
          path={`${match.url}`}
          render={() => <Redirect to={`${match.url}/list`} />}
        />
        <Route
          path={`${match.path}/list`}
          render={() => <VisitorTableComponent {...props} />}
        />
        <Route
          path={`${match.path}/log`}
          render={() => <VisitorLogTableComponent {...props} />}
        />
        <Route
          path={`${match.path}/manage`}
          component={ManageVisitorRouterComponent}
        />
        <Route
          path={`${match.path}/profile/:visitorId`}
          render={(props) => <VisitorProfileContainer {...props} />}
        />
        <Route
          path={`${match.path}/settings`}
          render={() => <VMSContainer {...props} />}
        />
      </Switch>
    </>
  );
};

VisitorRouterComponent.propTypes = {
  match: PropTypes.instanceOf(Object),
  location: PropTypes.instanceOf(Object),
};

export default VisitorRouterComponent;
